import { useState } from "react";
import { useAuth } from "../auth";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full" style={{ maxWidth: 420 }}>
        <div className="text-center mb-10">
          <div className="serif-display" style={{ fontSize: 46, color: "#0F172A" }}>GIANO</div>
          <div className="overline mt-2" style={{ color: "#64748B" }}>{t("admin.login.title")}</div>
          <p className="text-sm mt-4" style={{ color: "#64748B" }}>{t("admin.login.subtitle")}</p>
        </div>

        <form onSubmit={submit} className="admin-card p-8" data-testid="admin-login-form">
          <div className="mb-5">
            <label className="overline" style={{ color: "#64748B" }}>Email</label>
            <input required type="email" data-testid="login-email" className="admin-input mt-2"
                   value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="mb-5">
            <label className="overline" style={{ color: "#64748B" }}>Password</label>
            <input required type="password" data-testid="login-password" className="admin-input mt-2"
                   value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="text-sm mb-4" style={{ color: "#B91C1C" }} data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {loading ? "..." : t("admin.login.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
